if (
  (!window.chrome && !/CriOS|Version\/[\d.]+.*Safari/.test(navigator.userAgent) && getMode() !== 'APP' && !navigator.webdriver) ||
  /Edge/.test(navigator.userAgent)
) {
  window.location = './unsupported.html';
}

function getMode() {
  return ['0.0.0.0', 'localhost', '127.0.0.1'].indexOf(location.hostname) >= 0 ? 'LOCAL' : window._cordovaNative ? 'APP' : 'WEB';
}

const TESTENV = /test|uat|demo|regression|preprod|0.0.0.0|localhost|127.0.0.1/.test(location.hostname);

const CONSOLE_OVERRIDE_KEY = 'peekLogConsole';

/**
 * The Cordova app writes nothing to the console: on older WebViews console output is readable from
 * logcat over USB debugging (pen test 6.3.3). The on-device diagnostic log and the /Audits/message
 * upload are unaffected - see client-logger.ts.
 *
 * Only APP mode is quietened. Live Capture only ever runs in Cordova - ContextService.getContext()
 * throws ERR_DISALLOWED for LIVE in WEB mode unless you are admin - so a browser can neither reach
 * live data nor write to logcat in the first place. WEB and LOCAL stay fully verbose, as does any
 * test/UAT hostname, so developing against the APK is unchanged.
 */
function consoleDefault() {
  return TESTENV || getMode() !== 'APP';
}

/**
 * Explicit per-device override, persisted so it survives reloads and app restarts.
 * Returns true (force on), false (force off) or null (no override, use the default).
 *
 * WEB mode: set it with ?peekLogConsole=1 or ?peekLogConsole=0.
 *
 * APP mode: the query param is NOT reachable - the shell hardcodes the iframe URL
 * (www/index.ts: `iframe.src = `${url}/capture/index.html``) and there is no address bar, and a
 * release APK is non-debuggable so devtools cannot set localStorage either. On a device the only
 * way in is the "Enable Console Logging" item in the login hamburger menu (capture-root), which
 * writes this same key via DeviceSettingsService. It lives pre-login on purpose, so support can
 * capture a login failure.
 */
function consoleOverride() {
  try {
    const param = new URLSearchParams(location.search).get(CONSOLE_OVERRIDE_KEY);
    if (param === '1' || param === 'true') {
      localStorage.setItem(CONSOLE_OVERRIDE_KEY, 'true');
    } else if (param === '0' || param === 'false') {
      localStorage.setItem(CONSOLE_OVERRIDE_KEY, 'false');
    }
    const stored = localStorage.getItem(CONSOLE_OVERRIDE_KEY);
    return stored === null ? null : stored === 'true';
  } catch (_) {
    return null; // storage unavailable (private mode / blocked cookies)
  }
}

window.peekClientLogger = window.peekClientLogger || {};
window.peekClientLogger.exclusionPatterns = TESTENV ? [] : ['PEEK:LOG'];
window.peekClientLogger.serialization = !TESTENV;
window.peekClientLogger.consoleEnabled = consoleOverride() ?? consoleDefault();

// Google Analytics v4

function loadGA(propertyId) {
  const s = document.createElement('script');
  s.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${propertyId}`);
  s.async = true;
  document.body.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    dataLayer.push(arguments);
  };
  gtag('js', new Date());
  gtag('config', propertyId, { send_page_view: false });
}

const CAPTURE_GA_PROPERTIES = {
  TEST: 'G-SDGGE3BYSJ',
  LIVE: 'G-QCB5R1LBHF',
};

window.peekGaPropertyId = TESTENV ? CAPTURE_GA_PROPERTIES.TEST : CAPTURE_GA_PROPERTIES.LIVE;

loadGA(window.peekGaPropertyId);
